import PropTypes from 'prop-types';
import React from 'react';



const styles = require('./Callout-styles.module.scss');

const propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  theme: PropTypes.oneOf(['danger', 'warning']),
};

function Callout({ title, children, theme }) {
  return (
    <aside role="note" className={styles[theme || 'warning']}>
      {title && <header className="h5">{title}</header>}
      <div>{children}</div>
    </aside>
  );
}

Callout.propTypes = propTypes;

export default Callout;
